<template>
  <nav :class="style.navTop">
    <div
      v-for="item in navList"
      @click="navWidget = item"
      :class="
        navWidget == item ? style.active + ' ' + style.itemNav : style.itemNav
      "
    >
      <div v-text="item" />
    </div>
  </nav>
</template>
<script lang="ts">
import style from "../StyleWidget.module.scss";
import {defineComponent} from "vue";
export default defineComponent({
  name: "NavWidget",
  data() {
    return {
      style,
      navWidget: "УСЛУГИ",
      navList: ["УСЛУГИ", "ВРАЧИ"]
    };
  },
  watch: {
    navWidget(data) {
      this.$widgetStore.setNavWidget(data);
    }
  }
});
</script>
